var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLegal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "#25262F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1796 16.9296C26.4095 16.9288 24.9749 15.4943 24.9744 13.7245V10H15.0641C14.0034 10.003 13.144 10.8624 13.141 11.9231V33.0769C13.144 34.1376 14.0034 34.997 15.0641 35H29.9807C31.0416 34.997 31.9008 34.1376 31.9038 33.0769V16.9296H28.1796ZM16.609 19.8077H23.5384C23.8924 19.8077 24.1794 20.0947 24.1794 20.4487C24.1794 20.8028 23.8924 21.0897 23.5384 21.0897H16.609C16.255 21.0897 15.968 20.8028 15.968 20.4487C15.968 20.0947 16.255 19.8077 16.609 19.8077ZM29.0833 30.7885H16.609C16.255 30.7885 15.968 30.5016 15.968 30.1475C15.968 29.7934 16.255 29.5065 16.609 29.5065H29.0833C29.4373 29.5065 29.7243 29.7934 29.7243 30.1475C29.7243 30.5016 29.4373 30.7885 29.0833 30.7885ZM29.0833 25.936H16.609C16.255 25.936 15.968 25.6488 15.968 25.295C15.968 24.9409 16.255 24.6539 16.609 24.6539H29.0833C29.4373 24.6539 29.7243 24.9409 29.7243 25.295C29.7243 25.6488 29.4373 25.936 29.0833 25.936Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1795 15.6475H31.0128L26.2565 10.9039V13.7244C26.2572 14.7861 27.1176 15.6465 28.1795 15.6475Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegal);
export default __webpack_public_path__ + "static/media/icon_legal.aed4c9201d026b28c30612b47ae25e45.svg";
export { ForwardRef as ReactComponent };